import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.2929 0.292893C12.6834 -0.0976306 13.3164 -0.0976309 13.707 0.292893C14.0974 0.683423 14.0975 1.31646 13.707 1.70696L8.41399 6.99992L13.707 12.2929C14.0974 12.6834 14.0975 13.3165 13.707 13.707C13.3165 14.0975 12.6834 14.0974 12.2929 13.707L6.99992 8.41399L1.70696 13.707C1.31646 14.0975 0.683424 14.0974 0.292893 13.707C-0.0976311 13.3164 -0.0976311 12.6834 0.292893 12.2929L5.58586 6.99992L0.292893 1.70696C-0.097631 1.31643 -0.0976309 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31643 -0.0976311 1.70696 0.292893L6.99992 5.58586L12.2929 0.292893Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
